const Zoom = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width={12} height={8} fill="#FCFCFC" {...props}>
      <path d="M3.82.89H6.85A1.365 1.365 0 0 1 8.3 2.159V6.66c0 .407-.18.588-.588.588H1.444A1.362 1.362 0 0 1 .04 5.936V1.456c0-.407.181-.588.588-.588h3.19v.023ZM11.83 3.99v2.828a.405.405 0 0 1-.091.317.243.243 0 0 1-.317.045l-.022-.023c-.815-.633-1.652-1.267-2.467-1.9a.278.278 0 0 1-.113-.227V2.994c0-.09.046-.18.113-.226L11.423.8c.112-.09.293-.046.361.067.023.046.045.091.045.136V3.99Z" />
    </svg>
  );
};

export default Zoom;
